var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "users",
    clipPath: "url(#clip0_2956_1486)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M14.1673 17.5V15.8333C14.1673 14.9493 13.8161 14.1014 13.191 13.4763C12.5659 12.8512 11.718 12.5 10.834 12.5H4.16732C3.28326 12.5 2.43542 12.8512 1.8103 13.4763C1.18517 14.1014 0.833984 14.9493 0.833984 15.8333V17.5M19.1673 17.5V15.8333C19.1668 15.0948 18.9209 14.3773 18.4685 13.7936C18.016 13.2099 17.3824 12.793 16.6673 12.6083M13.334 2.60833C14.051 2.79192 14.6865 3.20892 15.1403 3.79359C15.5942 4.37827 15.8405 5.09736 15.8405 5.8375C15.8405 6.57764 15.5942 7.29673 15.1403 7.88141C14.6865 8.46608 14.051 8.88308 13.334 9.06667M10.834 5.83333C10.834 7.67428 9.3416 9.16667 7.50065 9.16667C5.6597 9.16667 4.16732 7.67428 4.16732 5.83333C4.16732 3.99238 5.6597 2.5 7.50065 2.5C9.3416 2.5 10.834 3.99238 10.834 5.83333Z",
    stroke: "#667085",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2956_1486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.851375301f9afc32e185d0c82503dca9.svg";
export { ForwardRef as ReactComponent };